"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var fetchManifest = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var tool, domain, toolPath, response, data, _t;
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          tool = _ref.tool, domain = _ref.domain, toolPath = _ref.toolPath;
          _context.prev = 1;
          _context.next = 2;
          return fetch("".concat(domain, "/").concat(toolPath, "build-manifest-").concat(tool, ".json"));
        case 2:
          response = _context.sent;
          _context.next = 3;
          return response.json();
        case 3:
          data = _context.sent;
          return _context.abrupt("return", data === null || data === void 0 ? void 0 : data['index.html']);
        case 4:
          _context.prev = 4;
          _t = _context["catch"](1);
          console.error("Failed to fetch manifest for tool ".concat(tool), _t);
          return _context.abrupt("return", {});
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 4]]);
  }));
  return function fetchManifest(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var _default = exports["default"] = fetchManifest;